import { PortalAddonCard } from '@/modules/portal/components/subscription-plans/PortalAddonCard';
import { PortalStagger } from '@/modules/portal/components/ui/portal-motion';

type PortalAddonsSectionProps = {
  locale: string;
};

/**
 * Standalone add-on purchase cards (branches, AI) shown on the upgrade page.
 * Each card independently fetches its own price and hides itself if the
 * add-on isn't available for the tenant's current plan tier (backend-enforced).
 */
export function PortalAddonsSection({ locale }: PortalAddonsSectionProps) {
  const isAr = locale.startsWith('ar');

  return (
    <section className="space-y-4">
      <div>
        <h2 className="text-base font-semibold text-foreground">
          {isAr ? 'إضافات على باقتك' : 'Add-ons for your plan'}
        </h2>
        <p className="text-sm text-muted-foreground">
          {isAr
            ? 'أضف ميزات إضافية لباقتك الحالية دون الحاجة لتغيير الباقة.'
            : 'Add extra features to your current plan without changing it.'}
        </p>
      </div>
      <PortalStagger className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <PortalAddonCard addonSlug="ai_tokens_200" locale={locale} />
        <PortalAddonCard addonSlug="ai_tokens_500" locale={locale} />
        <PortalAddonCard addonSlug="ai_tokens_1000" locale={locale} />
      </PortalStagger>
    </section>
  );
}
